import React, { Fragment, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import s from "./PauseMenu.module.scss"
import cx from "classnames"

import EventPubSub from "scripts/util/EventPubSub"

import GameButton from "components/GameButton"
import Instructions from "components/Instructions"

import store from "store"
import { setState } from "store/game"
import BackButton from "components/BackButton"
import AudioManager from "scripts/util/AudioManager"
import useQuery from "hooks/useQuery";

PauseMenu.defaultProps = {}

const translate = {
  pauseMenuBG : {
    en: {
      img: require("assets/images/en/pause/pause-menu.png").default,
    },
    es: {
      img: require("assets/images/es/pause/pause-menu.png").default,
    },
  },
  quitMenuBG : {
    en: {
      img: require("assets/images/en/pause/pause-quit-confirm.png").default,
    },
    es: {
      img: require("assets/images/es/pause/pause-quit-confirm.png").default,
    },
  },
}

export default function PauseMenu(props) {
  const lang = useQuery().get("lang") || "en";
  const [showQuitBtns, setshowQuitBtns] = useState(false)
  const [showInstructions, setshowInstructions] = useState(false)
  const paused = useSelector((state) => state.game.paused)

  const exitGame = () => {
    AudioManager.playSound("uiAccept")
    EventPubSub.emit("exitGame")
  }

  const playAgain = () => {
    AudioManager.playSound("uiAccept")
    EventPubSub.emit("playAgain")
  }

  useEffect(() => {
    console.log("paused")
  }, [paused])
  return (
    <div className={cx(s.PauseMenu, s.active)}>
      <div className={s.background}>
      </div>
      <div className={cx(s.menuWrapper, { [s.active]: !showInstructions })}>
        <img
          className={s.menu}
          src={showQuitBtns ? translate.quitMenuBG[lang].img : translate.pauseMenuBG[lang].img}
          alt="Menu"
        />
        <h1 className="visuallyhidden">Game Paused</h1>
        <div className={cx(s.btnWrapper, { [s.showQuite]: showQuitBtns })}>
          {showQuitBtns ? (
            <Fragment>
              <div className={s.GameButton}>
                <p className="visuallyhidden">
                  Are you sure you want to quit the game?
                </p>
              </div>
              <button
                aria-label="Quit"
                className={s.GameButton}
                onClick={exitGame}
              ></button>
              <button
                aria-label="Cancel"
                className={s.GameButton}
                onClick={() => {
                  AudioManager.playSound("uiSelect")
                  setshowQuitBtns(false)
                }}
              ></button>
            </Fragment>
          ) : (
            <Fragment>
              <button
                aria-label="Back"
                className={s.GameButton}
                onClick={() => {
                  AudioManager.playSound("uiSelect")
                  store.dispatch(setState({ paused: false }))
                  EventPubSub.emit("resume")
                }}
              ></button>
              <button
                aria-label="Restart"
                className={s.GameButton}
                onClick={playAgain}
              ></button>
              <button
                aria-label="How to Play"
                className={s.GameButton}
                onClick={() => {
                  AudioManager.playSound("uiSelect")
                  setshowInstructions(true)
                }}
              ></button>
              <button
                aria-label="Quit"
                className={s.GameButton}
                onClick={() => {
                  AudioManager.playSound("uiSelect")
                  setshowQuitBtns(true)
                }}
              ></button>
            </Fragment>
          )}
        </div>
      </div>
      {showInstructions && (
        <Instructions
          onComplete={() => {
            setshowInstructions(false)
          }}
          showReady={false}
          showBackground={false}
          className={s.Instructions}
        />
      )}
    </div>
  )
}
